module.exports = __webpack_public_path__ + "img/PGK.bb37697f.svg";